/**
 * Jeux de données de développement — jamais compilés en production.
 *
 * `NODE_ENV` vaut 'development' sous `npm start` et 'production' au build :
 * `DEV` est donc faux en production et les blocs qu'il garde ne s'y affichent
 * JAMAIS. Attention toutefois : vérification faite sur un vrai build, la
 * configuration CRA ne replie pas cette constante, donc le code reste présent
 * dans le bundle même s'il est inatteignable. Ne rien mettre derrière cette
 * garde qui serait dangereux À LIRE — secret, jeton, adresse interne.
 */
export const DEV = process.env.NODE_ENV === 'development';

/**
 * Image JPEG générée à la volée, pour satisfaire les contrôles de publication
 * qui exigent une photo. Un canvas plutôt qu'un fichier versionné : rien à
 * livrer, rien à charger, et l'image porte sa propre étiquette « test » pour
 * qu'on ne la confonde jamais avec une vraie.
 */
export async function fichierPhotoDeTest(libelle = 'Photo de test'): Promise<File> {
  const canvas = document.createElement('canvas');
  canvas.width = 800;
  canvas.height = 600;
  const ctx = canvas.getContext('2d');
  if (ctx) {
    ctx.fillStyle = '#d8cfc7';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#3b3330';
    ctx.font = 'bold 40px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(libelle, canvas.width / 2, canvas.height / 2);
  }
  const blob = await new Promise<Blob | null>((r) => canvas.toBlob(r, 'image/jpeg', 0.9));
  if (!blob) throw new Error("Génération de l'image impossible.");
  return new File([blob], 'photo-test.jpg', { type: 'image/jpeg' });
}
